<template>
	<svg class="nfc_x" viewBox="0 0 48 48">
		<rect x="8" y="12" width="32" height="24" rx="4" ry="4" stroke="#B00020" stroke-width="2.4" fill="none" />
		<path d="M14 16L34 30M34 16L14 30" stroke="#B00020" stroke-width="3" stroke-linecap="round" />
	</svg>
</template>
